import React, { Component } from 'react';
import './itemList.less';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class Item extends Component {
  render() {
    return (
      <div
        className={classnames(
          this.props.className,
          {
            active: this.props.active
          },
          'itemlist-item'
        )}
        title={this.props.title}
        onClick={this.props.action}
      >
        {this.props.children}
      </div>
    );
  }
}

Item.propTypes = {
  active: PropTypes.bool,
  name: PropTypes.string,
  subtext: PropTypes.string,
  action: PropTypes.func
};

class ItemList extends Component {
  render() {
    return (
      <div className="itemlist" title={this.props.title}>
        <div className="container">{this.props.children}</div>
      </div>
    );
  }
}

ItemList.Item = Item;

export default ItemList;
